var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfigureIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5934_391)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.25 7.50001H7.5V5.25001L4.875 2.62501C5.71472 2.22397 6.65812 2.09312 7.5753 2.25048C8.49247 2.40784 9.3383 2.84568 9.99632 3.50369C10.6543 4.16171 11.0922 5.00754 11.2495 5.92471C11.4069 6.84189 11.276 7.78529 10.875 8.62501L15.375 13.125C15.6734 13.4234 15.841 13.8281 15.841 14.25C15.841 14.672 15.6734 15.0766 15.375 15.375C15.0766 15.6734 14.672 15.841 14.25 15.841C13.828 15.841 13.4234 15.6734 13.125 15.375L8.625 10.875C7.78528 11.2761 6.84187 11.4069 5.9247 11.2495C5.00752 11.0922 4.16169 10.6543 3.50368 9.99633C2.84566 9.33832 2.40783 8.49248 2.25046 7.57531C2.0931 6.65814 2.22395 5.71473 2.625 4.87501L5.25 7.50001Z",
    stroke: "#0B51C5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5934_391"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfigureIcon);
export default __webpack_public_path__ + "static/media/configureIcon.2cefdabdefd443a6a52e512298ed0788.svg";
export { ForwardRef as ReactComponent };